import React, { Fragment, useState } from 'react';
import T from 'prop-types';
import { useIntl } from 'react-intl';

import {
  FLEX_DRAFT_SCHEDULE_BI_WEEKLY,
  FLEX_DRAFT_SCHEDULE_FORM_BI_WEEKLY_DICTIONARY,
  FLEX_DRAFT_SCHEDULE_FORM_COPY_DICTIONARY,
} from '@dmi/shared/redux/Payments/FlexDraft/constants';

import { FormattedMessage, KeyboardAvoidingScrollView } from '../../../base_ui';
import { SecondaryHeader } from '../../../ScreenHeaders';
import { InfoSection, RowButton } from '../../sharedComponents';
import {
  BiWeeklyContentContainer,
  BiWeeklyHeadingContainer,
  BiWeeklyInfoSectionWrapper,
  BoldText,
  FlexContainer,
  SelectButtonWrapper,
  StyledDivider,
  StyledH2,
  StyledLargePrimaryButton,
  StyledP2,
} from './styledComponents';

const ScheduleBiWeekly = ({
  dispatchChangeInput,
  dispatchSetSelectedDraftScheduleStep,
  formValues: { startingDay, startingMonth },
  navigation,
}) => {
  const { formatMessage } = useIntl();
  const [localStartingDay, setLocalStartingDay] = useState(startingDay);
  const [localStartingMonth, setLocalStartingMonth] = useState(startingMonth);

  const {
    heading,
    infoSectionData,
    selectButton,
    text,
    title,
  } = FLEX_DRAFT_SCHEDULE_FORM_COPY_DICTIONARY[FLEX_DRAFT_SCHEDULE_BI_WEEKLY];
  const {
    startingDay: startingDayDictionary,
    startingMonth: startingMonthDictionary,
  } = FLEX_DRAFT_SCHEDULE_FORM_BI_WEEKLY_DICTIONARY;

  const handleOnPressSelectStartDate = () => {
    // Update the redux form state with the selected payment dates in local state
    dispatchChangeInput({
      field: 'startingDay',
      form: FLEX_DRAFT_SCHEDULE_BI_WEEKLY,
      value: localStartingDay,
    });
    dispatchChangeInput({
      field: 'startingMonth',
      form: FLEX_DRAFT_SCHEDULE_BI_WEEKLY,
      value: localStartingMonth,
    });
    dispatchSetSelectedDraftScheduleStep({ step: '' });
    navigation.navigate('FlexDraftSetupOverview');
  };

  return (
    <Fragment>
      <SecondaryHeader
        handleBack={() => navigation.navigate('FlexDraftScheduleSelect')}
        title={title}
      />
      <KeyboardAvoidingScrollView scrollViewProps={{ showsVerticalScrollIndicator: false }}>
        <BiWeeklyContentContainer>
          <FlexContainer>
            <BiWeeklyHeadingContainer>
              <StyledH2>{heading}</StyledH2>
              {text.map((item) => (
                <FormattedMessage
                  key={item}
                  defaultMessage={formatMessage({ id: item })}
                  values={{
                    // eslint-disable-next-line react/prop-types
                    b: ({ msg }) => <BoldText>{msg}</BoldText>,
                  }}
                  WrapperComponent={StyledP2}
                />
              ))}
            </BiWeeklyHeadingContainer>
            <StyledDivider />
            <RowButton
              accessibilityName="starting-month"
              error={!localStartingMonth}
              isDropDown
              label={startingMonthDictionary.heading}
              menuItems={startingMonthDictionary.menuItems.map(
                ({ display, value }) => ({ label: display, value }),
              )}
              noValueErrorLabel="Select"
              onChange={(value) => setLocalStartingMonth(value)}
              selected={localStartingMonth}
            />
            <StyledDivider />
            <RowButton
              accessibilityName="starting-date"
              error={!localStartingDay}
              isDropDown
              label={startingDayDictionary.heading}
              menuItems={startingDayDictionary.menuItems.map(
                ({ display, value }) => ({ label: display, value }),
              )}
              noValueErrorLabel="Select"
              onChange={(value) => setLocalStartingDay(value)}
              selected={localStartingDay}
            />
            <StyledDivider />
            <BiWeeklyInfoSectionWrapper>
              <InfoSection data={infoSectionData} />
            </BiWeeklyInfoSectionWrapper>
          </FlexContainer>
        </BiWeeklyContentContainer>
      </KeyboardAvoidingScrollView>
      <SelectButtonWrapper>
        <StyledLargePrimaryButton
          disabled={!localStartingDay || !localStartingMonth}
          label={selectButton}
          onPress={handleOnPressSelectStartDate}
        />
      </SelectButtonWrapper>
    </Fragment>
  );
};

ScheduleBiWeekly.propTypes = {
  dispatchChangeInput: T.func.isRequired,
  dispatchSetSelectedDraftScheduleStep: T.func.isRequired,
  formValues:
    T.shape({
      startingDay: T.string.isRequired,
      startingMonth: T.string.isRequired,
    }).isRequired,
  navigation: T.object.isRequired,
};

export default ScheduleBiWeekly;
